export default __webpack_public_path__ + "static/media/1.8b7284f5.png";